import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { questions } from '../../content/faq';

// Every answer is rendered into the markup and collapsed with the `hidden` attribute rather
// than being mounted only when its item is open. The answers are the page's densest keyword
// text and they back the FAQPage structured data, so they have to exist in the server-rendered
// HTML a crawler sees, not only after a click.
const FAQ = ({ titleAs = 'h2' }) => {
    const [open, setOpen] = useState(0);
    const Title = titleAs;

    return (
        <section id="faq" className="section faq-section">
            <div className="site-container faq-layout">
                <div className="section-heading align-start compact">
                    <span>سوال‌های پرتکرار</span>
                    <Title>قبل از اولین غذا، جواب‌ها اینجاست</Title>
                    <p>
                        اگر پاسخ سوالت را پیدا نکردی، از{' '}
                        <Link className="inline-link" to="/contact">صفحه تماس با هوش‌پز</Link>{' '}
                        پیام بفرست.
                    </p>
                </div>
                <div className="faq-list">
                    {questions.map((item, index) => (
                        <article className={`faq-item ${open === index ? 'open' : ''}`} key={item.q}>
                            <button
                                type="button"
                                id={`faq-question-${index}`}
                                aria-controls={`faq-answer-${index}`}
                                aria-expanded={open === index}
                                onClick={() => setOpen(open === index ? -1 : index)}
                            >
                                <span>{item.q}</span><ChevronDown size={21} />
                            </button>
                            <div
                                className="faq-answer"
                                id={`faq-answer-${index}`}
                                role="region"
                                aria-labelledby={`faq-question-${index}`}
                                hidden={open !== index}
                            >
                                <p>{item.a}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
